<!--
 * @Descripttion: 满赠弹出框
 * @version:
 * @Author: Jeson
 * @Date: 2021-09-14 13:50:09
 * @LastEditors: Jerry
 * @LastEditTime: 2021-11-29 16:05:15
-->
<template>

  <el-dialog
    :visible.sync="show"
    width="50%"
    class="gift_daig"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    title=""
  >
    <!-- 赠品异常提醒弹窗  start-->
    <div
      v-if="type=='remind'"
      class="gift_daig_Msg"
    >
      <div class="gift_daig_title">赠品</div>
      <div class="gift_daig_content">
        <div
          v-for="(item,key) in GiftDaigInfo"
          :key="key"
          class="gift_daig_child_title"
        >
          <span class="item_name">活动{{ key+1 }}</span>
          <span class="item_type">以下{{ item.CheckFailType==1?'赠品已送完!':item.CheckFailType==2?'赠品库存不足!': '以下赠品已超出您的经营范围，无法赠送！' }}</span>
          <div class="gift_daig_content_good">
            <div
              v-for="(i,k) in item.ProductList"
              :key="k"
              class="gift_daig_content_itemGood"
            >
              <div class="gift_daig_content_img"><img :src="i.Img"></div>
              <div class="gift_daig_content_dec">
                <div class="tags_box">
                  <!-- 医保标签标签 -->
                  <div
                    v-for="properties in i.CommodityListProperties"
                    v-if="properties.AttributeName == '医保类型'"
                    :key="properties.Id"
                    style="margin-right: 4px; font-size: 0;"
                  >
                    <img
                      v-if="properties.Value == 1"
                      src="@/assets/goods/class_a.png"
                      width="28px"
                      height="16px"
                    >
                    <img
                      v-if="properties.Value == 2"
                      src="@/assets/goods/class_b.png"
                      width="28px"
                      height="16px"
                    >
                    <img
                      v-if="properties.Value == 3"
                      src="@/assets/goods/yibao.png"
                      width="28px"
                      height="16px"
                    >
                  </div>
                  <!-- 商品标签 -->
                  <img
                    v-if="i.GoodsTags && i.GoodsTags.length"
                    :src="i.GoodsTags[0].Img"
                    style="width: 32px; height: 16px;"
                  >
                  {{ i.Name }}
                </div>
                <div>
                  规格：{{ i.Specification }}
                </div>
                <div class="gift_daig_content_dec_last">
                  <span>赠送数量：{{ i.Amount }}</span>
                  <span>{{ i.Scope?'超出经营范围无法赠送':'' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div
      v-if="type=='remind'"
      class="daig_btn"
    >
      <el-button
        type="primary"
        @click.stop="surenext()"
      >继续购买</el-button>
    </div>
    <!-- 赠品异常提醒弹窗  end-->

    <!-- 选择赠品弹窗  start-->
    <div
      v-if="type=='chose'"
      class="gift_daig_Msg"
    >
      <div class="gift_daig_title">选择赠品</div>

      <div class="chose_div">
        <span class="item_type_chose">{{ '选送商品（请从列表中选择'+num+'个赠品）' }}</span>
        <div
          v-if="!!IsOutBusinessScopeStr"
          class="infoMsgDec"
        >提示：{{ IsOutBusinessScopeStr }}已超出您的经营范围，平台不会赠送！
        </div>
      </div>
      <div class="gift_daig_content">
        <div class="gift_daig_child_title">
          <div class="gift_daig_content_good">
            <div
              v-for="(i,k) in GiftInfo.GiftList"
              v-show="!i.IsMustSend"
              :key="k"
              :class="i.checked||i.IsMustSend?'gift_daig_content_itemGood checked':'gift_daig_content_itemGood' "
              @click.stop="changeChecked(i)"
            >
              <div class="gift_daig_content_img"><img :src="i.Type!=3?i.Logo:require('../assets/coupon.png')"></div>
              <div class="gift_daig_content_dec">
                <div class="tags_box">
                  <!-- 医保标签标签 -->
                  <div
                    v-for="properties in i.CommodityListProperties"
                    v-if="properties.AttributeName == '医保类型'"
                    :key="properties.Id"
                    style="margin-right: 4px; font-size: 0;"
                  >
                    <img
                      v-if="properties.Value == 1"
                      src="@/assets/goods/class_a.png"
                      width="28px"
                      height="16px"
                    >
                    <img
                      v-if="properties.Value == 2"
                      src="@/assets/goods/class_b.png"
                      width="28px"
                      height="16px"
                    >
                    <img
                      v-if="properties.Value == 3"
                      src="@/assets/goods/yibao.png"
                      width="28px"
                      height="16px"
                    >
                  </div>
                  <!-- 商品标签 -->
                  <img
                    v-if="i.GoodsTags && i.GoodsTags.length"
                    :src="i.GoodsTags[0].Img"
                    style="width: 32px; height: 16px;"
                  >
                  {{ i.Type==3?'优惠券':i.Name }}
                </div>
                <div v-if="i.Type!=3">
                  规格：{{ i.Specifications }}
                </div>
                <div v-if="i.Type==3">
                  满{{ i.GoodsLimitPrice }}元{{ i.DeductionMode==1?'减':'打' }}{{ i.DeductionLimit }}{{ i.DeductionMode==1?'元':'折' }}
                </div>
                <div class="gift_daig_content_dec_last">
                  <span>赠送数量：{{ i.Amount }} <label
                    v-if="Multiple>1"
                    class="number"
                  >x {{ Multiple }}</label></span>
                  <span v-show="i.IsOutBusinessScope">超出经营范围无法赠送</span>
                </div>
              </div>
              <div
                v-show="i.checked||i.IsMustSend"
                class="gift_daig_content_checked"
              ><img :src="require('../assets/checked.png')"></div>
            </div>
          </div>
        </div>

      </div>
      <!-- 已选列表 -->
      <div class="chose_div">
        <span class="item_type_chose">已选商品：</span>
      </div>
      <div class="gift_daig_content">
        <div class="gift_daig_child_title">
          <div class="gift_daig_content_good">
            <div
              v-for="(i,k) in ChoseGiftDaigInfo"
              :key="k"
              class="gift_daig_content_itemGood checked"
            >
              <div class="gift_daig_content_img"><img :src="i.Type!=3?i.Logo:require('../assets/coupon.png')"></div>
              <div class="gift_daig_content_dec">
                <div class="tags_box">
                  <!-- 医保标签标签 -->
                  <div
                    v-for="properties in i.CommodityListProperties"
                    v-if="properties.AttributeName == '医保类型'"
                    :key="properties.Id"
                    style="margin-right: 4px; font-size: 0;"
                  >
                    <img
                      v-if="properties.Value == 1"
                      src="@/assets/goods/class_a.png"
                      width="28px"
                      height="16px"
                    >
                    <img
                      v-if="properties.Value == 2"
                      src="@/assets/goods/class_b.png"
                      width="28px"
                      height="16px"
                    >
                    <img
                      v-if="properties.Value == 3"
                      src="@/assets/goods/yibao.png"
                      width="28px"
                      height="16px"
                    >
                  </div>
                  <!-- 商品标签 -->
                  <img
                    v-if="i.GoodsTags && i.GoodsTags.length"
                    :src="i.GoodsTags[0].Img"
                    style="width: 32px; height: 16px;"
                  >
                  {{ i.Type==3?'优惠券':i.Name }}
                </div>
                <div v-if="i.Type!=3">
                  规格：{{ i.Specifications }}
                </div>
                <div v-if="i.Type==3">
                  满{{ i.GoodsLimitPrice }}元{{ i.DeductionMode==1?'减':'打' }}{{ i.DeductionLimit }}{{ i.DeductionMode==1?'元':'折' }}
                </div>
                <div class="gift_daig_content_dec_last">
                  <span>赠送数量：{{ i.Amount }} <label
                    v-if="Multiple>1"
                    class="number"
                  >x {{ Multiple }}</label></span>
                  <span v-show="i.IsOutBusinessScope">超出经营范围无法赠送</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="type=='chose'"
      class="daig_btn"
    >
      <el-button
        type="primary"
        @click.stop="surenext()"
      >确定</el-button>
    </div>
    <!-- 选择赠品弹窗  end-->
  </el-dialog>
</template>

<script>
export default {
  name: 'GiftDaigItem',
  props: {
    // 选择赠品
    'GiftInfo': {
      type: Object,
      default: () => {
        return {
          ChooseGiftNum: '',
          GiftList: [],
          // 活动Id
          ActivityId: ''
        }
      }
    }

  },
  data() {
    return {
      show: false,
      // remind:异常提醒 chose:选择赠品
      type: 'remind',
      // 已选商品列表
      ChoseGiftDaigInfo: [],
      // 计算一共能选择赠品的数量
      TotalNum: 0,
      // 可以选择赠品的数量
      ChooseGiftNum: 0,
      // 异常弹窗集合
      GiftDaigInfo: [],
      // 超经营范围商品名称合集
      IsOutBusinessScopeStr: '',
      Multiple: 0,
      // 判断是否是订单满赠
      isByOrder: false,
      num: 0
    }
  },
  watch: {
    'show': function(val) {
      if (val) {
        this.ChooseGiftNum = this.GiftInfo.ChooseGiftNum
        this.num = this.GiftInfo.ChooseGiftNum
        this.TotalNum = this.TotalNum + this.ChooseGiftNum
        // 判断必送赠品
        this.checkMustSendGift()
        this.ChangeName()
      } else {
        // 初始化所以
        Object.assign(this.$data, this.$options.data.call(this))
        // 初始化赠品选择转台
        this.GiftInfo.GiftList.map(oo => {
          oo.checked = false
        })
      }
    }, deep: true,
    GiftInfo: {
      handler(v) {

      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    // 判断必送赠品
    // this.checkMustSendGift()
  },
  created() { },
  methods: {
    checkMustSendGift() {
      this.GiftInfo.GiftList.map(tt => {
        if (tt.IsMustSend) {
          this.TotalNum++
          this.ChoseGiftDaigInfo.push(tt)
        }
      })
    },
    surenext() {
      if (this.ChooseGiftNum != 0 && this.ChooseGiftNum !== null) {
        this.$toast({ position: 'bottom', message: '您还有' + this.ChooseGiftNum + '个赠品未选择' })
        return false
      }
      const submitList = []
      this.ChoseGiftDaigInfo.map(tt => {
        submitList.push(tt.GoodsSkuId)
      })
      let isByOrderOver = false
      if (this.isByOrder) {
        isByOrderOver = true
      }
      this.$emit('surenext', { List: submitList, ActivityId: this.GiftInfo.ActivityId, isByOrderOver: isByOrderOver })
    },
    // 点击选择
    changeChecked(val) {
      if (!val.IsMustSend) {
        if (val.checked) {
          val.checked = !val.checked
          this.ChoseGiftDaigInfo = this.ChoseGiftDaigInfo.filter(oo =>
            oo.GoodsSkuId != val.GoodsSkuId
          )
          this.ChooseGiftNum++
        } else {
          if (this.TotalNum != this.ChoseGiftDaigInfo.length) {
            val.checked = true
            this.ChoseGiftDaigInfo.push(val)
            this.ChooseGiftNum--
          } else {
            if (this.ChooseGiftNum != 0) {
              this.$toast({ position: 'bottom', message: '只能选择' + this.ChooseGiftNum + '个赠品' })
            }
          }
        }
        this.$forceUpdate()
      }
    },
    ChangeName() {
      let str = ''
      this.GiftInfo.GiftList.map(oo => {
        if (oo.IsOutBusinessScope) {
          str = str + oo.Name + '、'
        }
      })
      this.IsOutBusinessScopeStr = str
      return str
    }
  }
}
</script>

<style lang="less" scoped>
@import url("~@/components/style/GiftDaigItem");

/deep/.el-dialog__body {
  padding: 0;
}

/deep/.el-dialog__header {
  padding: 0;
}
</style>
